<template>
	<div v-show="showFlag">
		<payHeader :bgStatus="bgStatus"></payHeader>
		<div class="user-repwd">
			<div class="container">
				<div class="head">
					<h1>账号申诉</h1>
					<ul>
						<li class="step1 active">验证账号</li>
						<li class="step2">实名认证</li>
						<li class="step3">申诉资料</li>
						<li class="step4">等待审核</li>
					</ul>
				</div>
				<div class="tips" style="line-height: 28px;">申诉是指通过提交个人资料及帐号历史使用信息来证明您是帐号主人的方式。申诉适用于手机号码弃用、密码保护遗忘的情况，如果非上述情况请使用<router-link to="/repwd">找回密码</router-link>功能。<br/>申诉成功后可修改密码或密保，申诉结果一般会在1个工作日内发到您提交的新手机，如遇周末及法定节假日顺延。</div>
				<el-alert title="1、申诉期间帐号可正常使用，账户下的业务、服务、余额等不受申诉影响； 2、因帐号买卖、赠予、共用引起的申诉纠纷，蓝队云概不受理。" type="warning" show-icon :closable="false" style="margin: 20px 48px 0;" />
				<el-form :model="groupForm" v-if="!multipleFlag">
					<el-form-item v-if="loginType == 'mobile'">
						<span class="label">手机号码</span>
						<el-input v-model="groupForm.account" placeholder="手机号码" autocomplete="off" />
					</el-form-item>
					<el-form-item v-if="loginType == 'account'">
						<span class="label">账号/邮箱</span>
						<el-input v-model="groupForm.account" placeholder="用户名/邮箱" autocomplete="off" />
					</el-form-item>
					<el-form-item>
						<span class="label">验证码</span>
						<el-input v-model="groupForm.captcha_answer" autocomplete="off" />
					</el-form-item>
					<el-image :src="captchaImg" @click="captchaReload" fit="contain" alt="验证码" title="点击刷新" style="display: block; height: 80px; margin: 0 auto; cursor: pointer;" />
					<div class="other">
						<span @click="typeChange('mobile')" v-if="loginType == 'mobile'">账号或邮箱找回</span>
						<span @click="typeChange('account')" v-if="loginType == 'account'">手机号码找回</span>
					</div>
					<el-form-item>
						<el-button type="primary" class="submit" @click="submitForm('')">验证账号</el-button>
					</el-form-item>
				</el-form>
				<div class="check-account" v-else>
					<h4 class="title">您正在为帐户手机号绑定的账号找回密码，请选择绑定的其中一个账号：</h4>
					<ul class="repwd-select">
						<li v-for="(item, index) in multipleData" :key="index" :class="{ 'active': selectedMultiple === index }">
							<i class="pro"></i>
							<p>绑定的账号 <el-text type="warning">{{item.name}}</el-text></p>
							<span class="btn" @click="submitForm(item.key)">选择此账号</span>
						</li>
					</ul>
				</div>
			</div>
		</div>
		<payFooter></payFooter>
	</div>
</template>

<script setup>
	import { ref,reactive,onMounted} from 'vue';
	import { useRouter } from 'vue-router';
	import { captchaFetch,getuserhasproduct,appealAccount,appealStep } from '@/api/home';
	import { payHeader,payFooter } from 'landui-ui';
	
	const bgStatus = ref(true);
	const router = useRouter();
	const showFlag = ref(false);
	const multipleFlag = ref(false)
	const multipleData = ref();
	const loginType = ref('mobile');
	const token = ref('');
	const captchaId = ref('');
	const captchaImg = ref('');
	const groupForm = ref({account:'',captcha_answer:''});

	const appealStepF = () => {
		appealStep().then((res) => {
			if (res.code == 200) {
				switch(res.data.step)
				{
					case 0:
						showFlag.value = true;
					break;
					case 1:
						router.push({ path: '/appealAuth' })
					break;
					case 2:
						router.push({ path: '/appealInfo' })
					break;
					case 3:
						router.push({ path: '/appealStatus' })
					break;
				}
			}
		})
	}
	const captchaChange = () => {
		captchaFetch().then((res) => {
			if (res.code == 200) {
				captchaImg.value = res.data.captcha_data;
				captchaId.value = res.data.captcha_id;
			}
		})
	}
	const captchaReload = () => {
		captchaChange()
	}
	const typeChange = (e) => {
		switch(e)
		{
			case 'account':
				loginType.value = 'mobile';
				groupForm.value.account = ''
			break;
			case 'mobile':
				loginType.value = 'account';
				groupForm.value.account = ''
			break;
		}
	};
	const submitForm = (token) => {
		if (multipleFlag.value) {
			groupForm.value.type = 'token';
			groupForm.value.token = token;
		} else{
			groupForm.value.type = loginType.value;
		}
		groupForm.value.captcha_id = captchaId.value;
		const param = groupForm.value;
		appealAccount(param).then((res) => {
			if(res.code === 200){
				if (res.data.isChoose == '1') {
					const result = [];
					for (const [key, user] of Object.entries(res.data.userNameList)) {
					    result.push({ key, name: user.username });
					}
					multipleData.value = result;
					multipleFlag.value = true;
				} else{
					localStorage.setItem('appealAccount', res.data.account);
					router.push({ path: '/appealAuth' })
				}
			}else{
				captchaChange();
				groupForm.value.captcha_answer = ''
			}
		})
	};
	
	onMounted(() => {
		appealStepF();
		captchaChange();
	});
	
</script>

<style lang="scss" scoped>
	.user-repwd{
		.head h1{background: url(../../assets/images/appeal_icon.png) no-repeat left center;}
		.check-account{
			width: auto; 
			padding-top: 30px;
			margin: 0 48px !important;
			.title{text-align: left;color: #999;font-size: 14px;}
		}
		.repwd-select{
			li{ 
				min-height: 86px;
				padding-top: 28px;
				cursor: pointer;
				.pro{background:url(../../assets/images/appeal.png) no-repeat; background-size:contain}
			}
		}
	}
</style>